import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {
  CollectorAvailabilityFilter,
  CollectorAvailabilityOverviewRow
} from '../../domain/collector-availability-overview.model';

@Component({
  selector: 'app-collector-availability-list',
  templateUrl: './collector-availability-list.component.html',
  styleUrls: ['./collector-availability-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectorAvailabilityListComponent {
  @Input() rows: CollectorAvailabilityOverviewRow[] = [];
  @Input() count = 0;
  @Input() unavailableCount = 0;
  @Input() pageIndex = 0;
  @Input() pageSize = 20;
  @Input() pageSizeOptions: readonly number[] = [10, 20, 50];
  @Input() selectedFromMinute = 0;
  @Input() selectedToMinute = 1440;
  @Input() availabilityFilter: CollectorAvailabilityFilter =
    'availableAtLeastOnce';
  @Input() clearPinnedTick = 0;
  @Input() loading = false;
  @Input() error = '';
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() pinnedChange = new EventEmitter<boolean>();

  onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }
}
